<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 22C4 22 7 12 14 12C21 12 24 22 24 22" stroke="white" stroke-width="1.8" stroke-linecap="round" fill="none"/>
  <circle cx="14" cy="22" r="2" stroke="white" stroke-width="1.8" fill="none"/>
  <line x1="14" y1="20" x2="19" y2="10" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="6" y1="18" x2="7" y2="17" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="14" y1="10" x2="14" y2="9" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="22" y1="18" x2="21" y2="17" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
</svg>
